//
//
//
//
//
//
//
//

export default {
  props: {
    text: {
      type: String,
    },
    select: {
      type: Boolean,
    },
  },
  components: {},
};
